import { ChangeDate } from './ChangeDate';

const initChangeDate = () => {  
  new ChangeDate({
    timer: true,
    start: "2024-11-12",
    end: '',
    period: 2
  });
};

export default initChangeDate;
